import React from 'react';
import { useTranslation } from 'react-i18next';
import { BackButton } from '../components/ui/Buttons';
import { CrmTenantsEditor } from '../components/modules/SettingsPage';

const Settings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="settings page-section" id="settings">
      <div className="container">
        <div className="settings__inner">
          <BackButton backUrl="/">{t('settings')}</BackButton>
          <CrmTenantsEditor />
        </div>
      </div>
    </div>
  );
};

export default Settings;
